import React from "react";
import SwitchInput from "react-switch";
import { useTheme } from "styled-components";

import { hslToHex } from "../../utils/color";

interface Props {
  disabled?: boolean;
  checked?: boolean;
  onChange: (
    checked: boolean,
    event: MouseEvent | React.SyntheticEvent<MouseEvent | KeyboardEvent, Event>,
    id: string,
  ) => void;
}

const Switch: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const theme = useTheme();
  const switchColor = theme.colors?.accent?.color || [200, 100, 30];
  return (
    <>
      <SwitchInput
        disabled={props.disabled}
        checked={props.checked || false}
        uncheckedIcon={false}
        checkedIcon={false}
        height={12}
        width={20}
        onColor={hslToHex(...switchColor)}
        onChange={props.onChange}
      />
    </>
  );
};

export default Switch;
